import { render } from "./ProjectsListScrum.vue?vue&type=template&id=f5c0b7b6&scoped=true"
import script from "./ProjectsListScrum.vue?vue&type=script&lang=js"
export * from "./ProjectsListScrum.vue?vue&type=script&lang=js"

import "./ProjectsListScrum.vue?vue&type=style&index=0&id=f5c0b7b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c0b7b6"]])

export default __exports__